import { render } from "./TradeInvestmentMap.vue?vue&type=template&id=031bb4f6&scoped=true"
import script from "./TradeInvestmentMap.vue?vue&type=script&lang=js"
export * from "./TradeInvestmentMap.vue?vue&type=script&lang=js"

import "./TradeInvestmentMap.vue?vue&type=style&index=0&id=031bb4f6&scoped=true&lang=scss"
import "./TradeInvestmentMap.vue?vue&type=style&index=1&id=031bb4f6&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-031bb4f6"]])

export default __exports__